module.exports = __webpack_public_path__ + "img/5-Howdie-Geyser-Step-4-Photos-Preview-Page-MVP.9b36a957.png";